export const GOOGLE_PLACES_API_KEY = 'AIzaSyDrp9cfe22w4lmSru9GbKveLw4fwRmb7fM'
export const language = 'en'
export const USE_STORYBOOK = false

// USE THIS TO CHANGE THE ENVIRONMENT
const ENVIRONMENT: 'production' | 'development' | 'test' = process.env.NODE_ENV

let HTTPS = false

// @ts-expect-error
if (ENVIRONMENT === 'production' || ENVIRONMENT === 'staging') {
  HTTPS = true
}

const getEnvironmentURI = (environment: 'production' | 'development' | 'test'): string => {
  if (environment === 'production') {
    return 'pickleplay-app.com'
  }
  if (environment === 'development') {
    // return 'api.pickle-play-dev.com'
  }

  return 'localhost:8000'
}

const DOMAIN = getEnvironmentURI(ENVIRONMENT)
export const BACKEND_URL = `http${HTTPS ? 's' : ''}://${DOMAIN}`
export const BASE_URL = `${BACKEND_URL}/api`
// export const BASE_URL = 'https://full-donuts-follow-172-58-128-86.loca.lt/api'
export const BASE_WEBSOCKET_URL = `ws${HTTPS ? 's' : ''}://${DOMAIN}/ws`
